import { useState } from "react";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import { CertificateContext } from "./context/certificate";
import { ProfileContext } from "./context/profile";
// import { RoleContext } from "./context/roleContext";
import { SideNavContext } from "./context/sideNav";
import router from "./routes";

function App() {
  const [currentCertificate, setCurrentCertificate] = useState({});
  // const [role, setRole] = useState(null);
  const [open, setOpen] = useState(false);
  const temp2 = localStorage.getItem("user");
  let temp;
  try {
    temp = JSON.parse(temp2);
  } catch (e) {
    localStorage.clear();
    window.location.replace("/agent/login");
  }
  const [profile, setProfile] = useState(temp);
  return (
    <>
      <ProfileContext.Provider value={{ profile: { profile, setProfile } }}>
        <CertificateContext.Provider
          value={{ certificate: { currentCertificate, setCurrentCertificate } }}
        >
          {/* <RoleContext.Provider value={{role:{role,setRole}}}> */}
          <SideNavContext.Provider value={{ open, setOpen }}>
            <RouterProvider router={router} />
          </SideNavContext.Provider>
          {/* </RoleContext.Provider> */}
        </CertificateContext.Provider>
      </ProfileContext.Provider>
    </>
  );
}

export default App;
